import React, { useState, useEffect } from "react";
import { useParams, useNavigate } from "react-router-dom";
import MobileMerchandising from "./MobileMerchandising";
import DesktopMerchandising from "./DesktopMerchandising";
import useSystemHook from "./../../hooks/SystemHook";

const Merchandising = () => {
  const { category } = useParams();
  const navigate = useNavigate();

  const [selectedCategory, setSelectedCategory] = useState("BETA");

  const { isMobile } = useSystemHook();

  useEffect(() => {
    if (!category) {
      navigate("/merchandising/beta", { replace: true });
      return;
    }

    const upperCategory = category.toUpperCase();
    const validCategories = ["BETA", "M7", "FLIGHT"];

    if (validCategories.includes(upperCategory)) {
      setSelectedCategory(upperCategory);
    } else {
      // Invalid category → redirect to beta
      navigate("/merchandising/beta", { replace: true });
    }
  }, [category, navigate]);

  const categories = [{ title: "BETA" }, { title: "M7" }, { title: "FLIGHT" }];

  const handleCategorySelect = (categoryTitle) => {
    setSelectedCategory(categoryTitle);

    const slug = categoryTitle.toLowerCase();

    if (slug === "beta") {
      navigate("/merchandising/beta", { replace: true });
    } else {
      navigate(`/merchandising/${slug}`, { replace: true });
    }
  };

  return (
    <>
      {isMobile ? (
        <MobileMerchandising
          categories={categories}
          selectedCategory={selectedCategory}
          handleCategorySelect={handleCategorySelect}
        />
      ) : (
        <DesktopMerchandising
          categories={categories}
          selectedCategory={selectedCategory}
          handleCategorySelect={handleCategorySelect}
        />
      )}
    </>
  );
};

export default Merchandising;
